import { render, staticRenderFns } from "./Debugger.vue?vue&type=template&id=5b6bc32c&scoped=true&"
import script from "./Debugger.vue?vue&type=script&lang=ts&"
export * from "./Debugger.vue?vue&type=script&lang=ts&"
import style0 from "./Debugger.vue?vue&type=style&index=0&id=5b6bc32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6bc32c",
  null
  
)

export default component.exports